import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../atoms/Button/Button";
import { subscribeToAlerts } from "../../../services/formService";

const AlertSubscriptionForm = ({ buttonLabel }) => {
  const [email, setEmail] = useState("");
  const [zones, setZones] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    subscribeToAlerts({ email, zones });
    navigate("/notifications");
  };

  return (
    <form className="modal-form" onSubmit={handleSubmit}>
      <label className="modal-label">
        Email professionnel
        <input
          type="email"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
      </label>
      <label className="modal-label">
        Départements (jusqu'à 2)
        <input
          type="text"
          placeholder="ex : 06, 83"
          value={zones}
          onChange={(event) => setZones(event.target.value)}
        />
      </label>
      <Button label={buttonLabel} variant="primary" type="submit" fullWidth />
    </form>
  );
};

export default AlertSubscriptionForm;
